module.exports = __webpack_public_path__ + "static/work_Borstnikovo_2023-b0af6099cd98c4f3b7caf97dc12ba307.mp4";